exports.DEADLINE = new Date("2026-05-31T23:59:59.999Z");
exports.OPEN = new Date("2026-01-20");

